<div class="dialog">
    <h2 class="dialog__title">Optimize trip</h2>

    <p class="dialog__description">
        By letting our experts optimize your trip some changes might occur like change in cities visited, changes in
        number of nights etc.
        <br/>
        <br/>
        You can always use the undo button and change your trip.
    </p>

    <div class="dialog__actions">
        <button class="dialog__button dialog__button--cancel" (click)="closeModal(false)">Cancel</button>
        <button class="dialog__button dialog__button--confirm" (click)="closeModal(true)">Optimize</button>
    </div>
</div>
